export function shortAddr(addr: string): string {
  if (!addr || addr.length < 10) return addr || '-';
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
}

export function fmtToken(amount: bigint, decimals = 6): string {
  const n = Number(amount) / 10 ** decimals;
  return `${n.toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
}

export function fmtPct(numerator: bigint, denominator: bigint): string {
  const den = Number(denominator || 1n);
  const num = Number(numerator);
  const pct = (num / den) * 100;
  return `${pct.toFixed(1)}%`;
}

export function fmtDuration(seconds: number): string {
  if (seconds <= 0) return 'Now';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 24) return `${Math.floor(h / 24)}d ${h % 24}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}
